import { render, staticRenderFns } from "./noticeDetails.vue?vue&type=template&id=13dbe53f"
import script from "./noticeDetails.vue?vue&type=script&lang=js"
export * from "./noticeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports